import { ReactNode } from "react";
import { AccordionItemWrapper } from "./styled.styles";
import { classNames } from "helpers/themeHelpers";
import IconDownArrowHead from "assets/icons/IconDownArrowHead";
import { useTheme } from "styled-components";
import { useGetSeoPage } from "contexts/SeoContext";

export interface AccordionData {
  title: string;
  content?: ReactNode;
  hiddenContent?: ()=>ReactNode;
  customCont?:string;
  titleFont?: string;
}

function AccordionItem({
  data,
  isOpen,
  btnOnClick,
  className = "",
  headerClassName = "",
  hasHtml = false,
  tabLink = null,
  gtm = null,
  customCont = "",
}: {
  data: AccordionData;
  isOpen: boolean;
  customCont: string;
  btnOnClick: () => void;
  className?: string;
  headerClassName?: string;
  hasHtml: boolean;
  tabLink?: string;
  gtm?: () => void;
}) {
  const { isMobile, isDesktop } = useTheme();
  const seoPage = useGetSeoPage();
  const articleText = (seoPage?.pageArticle || "").replace(/_/g, " ");
  function renderHeader() {
    return tabLink ? (
      <a
        {...classNames(
          isMobile && "font-15",
          isDesktop && "font-18",
          headerClassName,
          "blackColor"
        )}
        href={tabLink}
      >
        <h2 {...classNames(data.titleFont? `${data.titleFont}`: "normalFont")}>{data.title}</h2>
      </a>
    ) : (
      <h2
        {...classNames(

          isMobile && "font-16",
          isDesktop && "font-18",
          headerClassName
        )}
      >
        {data.title}
      </h2>
    );
  }

  return (
    <>
      {hasHtml === false ? (
        <AccordionItemWrapper
          {...classNames("accordion borderBottom", isOpen && "active" , className)}
        >
          <div
            {...classNames(
              "accordionHeader flex flexSpaceBetween alignItems pointer",
              isMobile && "p-16"
            )}
            onClick={() => {
              btnOnClick();
              !isOpen && gtm && gtm();
            }}
          >
            {renderHeader()}
            <IconDownArrowHead
              {...classNames(isOpen && "rotateUp")}
              fill="#000"
            />
          </div>
          <div {...classNames("accordionContent overflowHidden  ps-8 pe-8 font-15 darkGrayColor")}>
              {data.hiddenContent && isOpen && data.hiddenContent()}
              {data.content ? data.content : null}
          </div>
        </AccordionItemWrapper>
      ) : (
        <AccordionItemWrapper
          {...classNames("accordion borderBottom", isOpen && "active",className)}
        >
          <div
            {...classNames(
              "accordionHeader flex flexSpaceBetween alignItems",
              isMobile && "p-16"
            )}
            onClick={btnOnClick}
          >
            <h2
              className="normalFont"
              dangerouslySetInnerHTML={{
                __html: seoPage?.pageH1
              }}
            />
            <IconDownArrowHead
              {...classNames(isOpen && "rotateUp")}
              fill="#000"
            />
          </div>
          <div className="accordionContent overflowHidden ps-16 pe-8">
            <div
              dangerouslySetInnerHTML={{
                __html: articleText,
              }}
            />
          </div>
        </AccordionItemWrapper>
      )}
    </>
  );
}

export default AccordionItem;
